import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  labelInput: {
    color: '#696969',
    fontSize: '16px',
    whiteSpace: 'nowrap',
  },
}))
